// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/Patient/Content/PatientTrigger/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_Patient_Content_PatientTrigger_Content($patient_id: uuid!) {
  vaxiom_patients(where: { _id: { _eq: $patient_id } }) {
    id
    person {
      id
      greeting
      first_name
      last_name
    }
  }
}

`